import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import LandingPage from "@/pages/LandingPage";
import SuccessPage from "@/pages/SuccessPage";
import CancelPage from "@/pages/CancelPage";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import CookiePolicy from "@/pages/CookiePolicy";
import Termini from "@/pages/Termini";
import NoteLegali from "@/pages/NoteLegali";
import ConsulenzaPage from "@/pages/ConsulenzaPage";
import CertificazionePage from "@/pages/CertificazionePage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminDashboardPage from "@/pages/AdminDashboardPage";
import AreaIscrittiPage from "@/pages/AreaIscrittiPage";
import QuizPage from "@/pages/QuizPage";
import LibreriePage from "@/pages/LibreriePage";
import LibrerieDashboardPage from "@/pages/LibrerieDashboardPage";
import { installAutoTracking, trackPageview } from "@/lib/tracker";

function TrackingBridge() {
  const location = useLocation();
  useEffect(() => {
    // Skip admin & area-iscritti routes — focus analytics on public funnel
    if (location.pathname.startsWith("/admin")) return;
    trackPageview(location.pathname + location.search);
  }, [location.pathname, location.search]);
  return null;
}

function App() {
  useEffect(() => { installAutoTracking(); }, []);
  return (
    <div className="App" data-testid="app-root">
      <BrowserRouter>
        <TrackingBridge />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/success" element={<SuccessPage />} />
          <Route path="/cancel" element={<CancelPage />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/cookie" element={<CookiePolicy />} />
          <Route path="/termini" element={<Termini />} />
          <Route path="/note-legali" element={<NoteLegali />} />
          <Route path="/consulenza" element={<ConsulenzaPage />} />
          <Route path="/certificazione" element={<CertificazionePage />} />
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route path="/admin" element={<AdminDashboardPage />} />
          <Route path="/area-iscritti" element={<AreaIscrittiPage />} />
          <Route path="/quiz" element={<QuizPage />} />
          <Route path="/librerie" element={<LibreriePage />} />
          <Route path="/librerie/dashboard" element={<LibrerieDashboardPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" />
    </div>
  );
}

export default App;
